import { getCarouselChartDetailInfo } from "@/apis/user"
import { create } from "zustand"

export type ActivePageDetailType = {
    content: string,id:number,
    imgAddr: string,
    title: string
}

export type ActivePageStore = {
    activePageDetailMap: Map<string, ActivePageDetailType>,
    getActivePageDetail: (id: string) => void,
}

export const useActivePageStore = create<ActivePageStore>((set, get) => {
    return{
        activePageDetailMap: new Map(),
        getActivePageDetail: async (id: string) => {
            const res = await getCarouselChartDetailInfo({id: Number(id)});
            const {activePageDetailMap} = get();
            const newMap = new Map(activePageDetailMap);
            newMap.set(id, res.data);
            set({activePageDetailMap: newMap});
        }, 
    }
})